import { MyClassIcon } from "../icons";
import type { NavBarItem } from "../types/nav";
import { ROUTERS } from "./router";

export const navbarItems: NavBarItem[] = [
  // {
  //   name: "Dashboard",
  //   icon: IconDashboard,
  //   key: ROUTERS.HOME,
  // },
  {
    name: "My class",
    icon: MyClassIcon,
    key: ROUTERS.HOME,
  },
];
